var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component"},[(_vm.allDay)?[_vm._v(" "+_vm._s(_vm.$t('calendar.meeting-form.all-day'))+" ")]:(!_vm.endDate)?[_vm._v(" "+_vm._s(_vm._f("moment")(_vm.startDate,"HH:mm"))+" ")]:[_vm._v(" "+_vm._s(_vm.range)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }